<template>
  <Toast />
  <Dialog v-model:visible="showErrorDialog" modal :header="'Terjadi Kesalahan'" :closable="true"
    class="w-[90vw] md:w-[50vw]">
    <div class="flex items-start space-x-3">
      <ExclamationCircleIcon class="h-6 w-6 text-red-500" />
      <p class="text-gray-700 dark:text-gray-200">{{ errorMessage }}</p>
    </div>
    <template #footer>
      <Button label="Tutup" @click="showErrorDialog = false" severity="secondary" />
    </template>
  </Dialog>
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <IndexView />
  <ViewContainer>
    <section class="p-6">
      <PageTitle :title="isEdit ? 'Edit Pelanggan' : 'Tambah Pelanggan'" />
      <div class="w-full bg-white dark:bg-dark-900 p-6 rounded-md shadow-md space-y-3">
        <InputTextCustom id="customer-fullname" v-model="customer.fullName" input_class="w-full" label="Nama Lengkap"
          label_class="block text-start" type="text" placeholder="Nama depan" :valid="validation.name.valid" :error-message="validation.name.message"/>
        <InputTextCustom id="customer-email" v-model="customer.email" input_class="w-full" label="Email"
          label_class="block text-start" type="email" placeholder="example@mail.com" :valid="validation.email.valid" :error-message="validation.email.message"/>
        <InputTextCustom id="customer-phone" v-model="customer.phone" input_class="w-full" label="No Telepon"
          label_class="block text-start" type="text" placeholder="Cth: 081234567890" :valid="validation.phone.valid" :error-message="validation.phone.message"/>
        <InputSelect v-model="customer.city" id="category-select" label="Category" :options="optionCity"
          placeholder="Pilih kota" :valid="validation.city.valid"
          :error-message="validation.city.message" :isScrolled="true" option-label="name" option-value="name" />
        <InputTextAreaCustom id="customer-address" v-model="customer.address" input_class="w-full" label="Alamat"
          label_class="block text-start" placeholder="Alamat" :valid="validation.address.valid" :error-message="validation.address.message" />

        <div class="flex justify-center">
          <BackButton class="mx-1" to_url="/pelanggan" />
          <Button type="submit" label="Simpan" :loading="loading" @click="submit" />
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import { mapActions } from 'vuex';
import InputTextAreaCustom from '@/components/form/InputTextAreaCustom.vue';
import InputTextCustom from '@/components/form/InputTextCustom.vue';
import { Button, ConfirmDialog, Dialog, Toast } from 'primevue';
import ViewContainer from '@/components/ViewContainer.vue';
import InputSelect from '@/components/form/InputSelect.vue';
import { kota } from '@/helpers/kota';

export default {
  name: "AddEditCustomer",
  props: ['id'],
  components: {
    IndexView, PageTitle, BackButton, InputTextCustom, InputTextAreaCustom, Toast, Dialog, Button, ConfirmDialog, ViewContainer, InputSelect
  },
  data() {
    return {
      customer: {
        id: null,
        fullName: '',
        email: '',
        phone: '',
        address: '',
        city: null,
      },
      isEdit: false,
      optionCity: kota,
      validation: {
        name: {
          valid: true,
          message: ''
        },
        email: {
          valid: true,
          message: ''
        },
        phone: {
          valid: true,
          message: ''
        },
        address: {
          valid: true,
          message: ''
        },
        city: {
          valid: true,
          message: ''
        },
      },
      field: ['name', 'email', 'phone', 'address', 'city'],
      showErrorDialog: false,
      errorMessage: '',
      loading: false,
    }
  },
  methods: {
    ...mapActions('customers', ['createCustomer', 'updateCustomer', 'fetchCustomerById']),
    async submit() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan pelanggan?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postCustomer();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan pelanggan', life: 3000 });
        }
      });
    },
    async postCustomer() {
      try {
        this.loading = true;
        this.field.forEach((field) => {
          this.validation[field].valid = true;
          this.validation[field].message = '';
        });
        const customerData = {
          id: this.id,
          fullname: this.customer.fullName,
          email: this.customer.email,
          phone: this.customer.phone,
          address: this.customer.address,
          city: this.customer.city,
        };

        let isError = false;
        if(this.customer.fullName === '' || this.customer.fullName === null) {
          this.validation['name'].valid = false;
          this.validation['name'].message = 'Nama tidak boleh kosong';
          isError = true;
        }

        if(this.customer.phone === '' || this.customer.phone === null) {
          this.validation['phone'].valid = false;
          this.validation['phone'].message = 'No Telepon tidak boleh kosong';
          isError = true;
        }

        if(isError) {
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data pelanggan tidak valid', life: 5000 });
          return;
        }

        if (this.isEdit) {
          await this.updateCustomer(customerData);
        } else {
          await this.createCustomer(customerData);
        }
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Data pelanggan berhasil disimpan!', life: 5000 });
        this.$router.push('/pelanggan');
      }
      catch (error) {
        console.error('Failed to update user', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  },
  async created() {
    const customerId = this.id;

    if (customerId) {
      this.isEdit = true;

      try {
        const response = await this.fetchCustomerById(customerId);
        const customerData = response.data;

        this.customer = {
          id: customerData.id,
          fullName: customerData.fullname,
          email: customerData.email,
          phone: customerData.phone,
          address: customerData.address,
          city: customerData.city,
        }
      }
      catch (error) {
        console.error('Failed to fetch customer', error);
      }
    }
  },
}
</script>